import React from 'react'

const PageTitle = ({children}) => {
  return (
    <h1 className="my-2 text-2xl font-medium text-gray-500">{children}</h1>
  )
}

export default PageTitle